function WarningMessage({ msg }) {
  return (
    <div className="warning-message">{msg}</div>
  )
};

export default WarningMessage;